import { render, staticRenderFns } from "./MaterialAdminOrders.vue?vue&type=template&id=5c9a3c94&scoped=true"
import script from "./MaterialAdminOrders.vue?vue&type=script&lang=js"
export * from "./MaterialAdminOrders.vue?vue&type=script&lang=js"
import style0 from "./MaterialAdminOrders.vue?vue&type=style&index=0&id=5c9a3c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a3c94",
  null
  
)

export default component.exports